/**
 * A Pinia store for exposing feature flags reactively in the application.
 * @module
 */

import { createFlagStore } from '@thyme/libs/src/flags/store'
import { _featureFlagDefinitions } from './core'

export const useFlagStore = createFlagStore(_featureFlagDefinitions)
